import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppTextarea = /*#__PURE__*/function (_Vue) {
  _inherits(AppTextarea, _Vue);

  var _super = _createSuper(AppTextarea);

  function AppTextarea() {
    var _this;

    _classCallCheck(this, AppTextarea);

    _this = _super.apply(this, arguments);
    _this.model = '';
    _this.rules = {
      required: function required(value) {
        return !!value || 'Required.';
      }
    };
    return _this;
  }

  _createClass(AppTextarea, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val) {
      this.model = val;
      return val;
    }
  }]);

  return AppTextarea;
}(Vue);

__decorate([Prop(String)], AppTextarea.prototype, "value", void 0);

__decorate([Prop(String)], AppTextarea.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppTextarea.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppTextarea.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppTextarea.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppTextarea.prototype, "height", void 0);

__decorate([Emit('input')], AppTextarea.prototype, "valueChangedHandler", null);

AppTextarea = __decorate([Component], AppTextarea);
export default AppTextarea;